import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { AdjustmentProfileAction } from '@cbridge-packages/adjustment-profile';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { mergeMap } from 'rxjs';

export const loadAdjustmentListAfterCreateEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(AdjustmentProfileAction.create.done),
  mergeMap(() => {
    return [AdjustmentProfileAction.loadList.started(), DetailsSidebarAction.close()];
  }),
);
